"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_components_1 = require("@codametrix/ui-components");
var CancelledEula = function (props) {
    var onEulaCancel = props.onEulaCancel, modalProps = props.modalProps;
    var submitClick = function (e) {
        onEulaCancel(false);
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: 'qa-cancelled-eula' }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ title: 'You must accept the EULA to use the application', buttonText: 'Return', closable: false, onSubmit: submitClick, forceSubmitOptions: {
                isForced: true,
                time: 10,
                message: 'Returning to the login screen '
            } }, modalProps, { children: (0, jsx_runtime_1.jsx)("p", { children: "Please review the EULA and try again." }) })) })));
};
CancelledEula.displayName = 'CancelledEula';
exports["default"] = CancelledEula;
//# sourceMappingURL=cancelled-eula.js.map